<template>
    <LayoutSub className="online">
        <SubpageTitleContainer :title="`이지페이(EasyPay)`"
            :subText="`다양한 결제수단을 이용하여 상품과 서비스를 편리하게 결제할 수 있도록 지원하는 전자결제 서비스입니다.<br />이지페이 통합 결제 시스템을 통해 간편하고 안전한 전자상거래 인프라를 구축해보세요.`">
            <RedLineButton :type="`inbound`" :text="`바로가기`" href="https://www.easypay.co.kr/" />
            <!-- <RedLineButton :type="`inbound`" :text="`자료다운로드`" /> -->
        </SubpageTitleContainer>

        <SubSection class="pt-0">
            <div class="table-3grid">
                <TableRow_3grid :title="`쉽고 편리하고 안전한 결제 솔루션`"
                    :list="['다양한 결제수단을 하나의 통합 결제창에서 이용', '강력한 보안시스템으로 보안사고를 원천적으로 방지']" :src="`sub02_top_icon01.png`" />
                <TableRow_3grid :title="`우수한 웹 접근성 제공`" :list="['웹 접근성 표준지침에 따른 디자인 적용', '정보취약계층의 서비스 이용 불편함 최소화']"
                    :src="`sub02_top_icon02.png`" />
                <TableRow_3grid :title="`Non-Active X 적용`"
                    :list="['언제 어디서나 어떤 환경에서도 편리하게 결제 가능', 'Active X 설치 없는 멀티 플랫폼/멀티 웹 브라우징 지원']"
                    :src="`sub02_top_icon03.png`" />
            </div>
        </SubSection>
        <SubSection type="wide">
            <SubTitle3 listStyle="dot">결제서비스</SubTitle3>
            <div class="image-list-wrap">
                <ImageListItem title="신용카드" desc="국내 전 카드를 포함한 해외 카드(VISA, MASTER 등) 결제 서비스를 지원합니다."
                    src="sub02_image1.png" />
                <ImageListItem title="간편결제"
                    desc="카카오페이, 네이버페이, PAYCO, 삼성페이, 애플페이 등 다양한 간편결제 서비스를 제공하며 간편결제사와의 개별 계약 없이 KICC 단일 계약으로 통합 관리가 가능합니다."
                    src="sub02_image2.png" />
                <ImageListItem title="실시간 계좌이체" desc="고객의 계좌에서 결제 대금이 실시간으로 출금되며 신용카드와 같이 결제 결과도 자동으로 처리됩니다."
                    src="sub02_image3.png" />
                <ImageListItem title="가상계좌" desc="고객이 일회성으로 발급받은 계좌로 직접 입금하는 서비스로 <br />입금 금액과 주문 금액이 일치하는지 대사 후 처리합니다."
                    src="sub02_image4.png" />
                <ImageListItem title="휴대폰 소액결제" desc="휴대폰 SMS 인증을 통해 진행하며 1,000원 미만의 <br />소액도 결제 가능합니다."
                    src="sub02_image5.png" />
                <ImageListItem title="이지페이 간편결제 (가맹점 간편결제)" desc="이지페이와 연동하여 쉽고 간편하게 가맹점 전용 간편결제를 구축할 수 있습니다."
                    src="sub02_image6.jpg" />
            </div>
        </SubSection>

        <SubSection>
            <SubTitle3 listStyle="dot">부가서비스</SubTitle3>
            <div class="table-2grid">
                <TableRow_2grid :title="`에스크로`" :content="`고객이 구매확정을 한 이후 대금을 지급하는 서비스입니다.`"
                    :src="`sub02_icon01.png`" />
                <TableRow_2grid :title="`현금영수증`"
                    :content="`가맹점에서 발생하는 모든 현금거래에 대해서 한국정보통신의 현금영수증 시스템을 통해 영수증을 발급하고 결제내역을 국세청에 통보합니다.`"
                    :src="`sub02_icon02.png`" />
                <TableRow_2grid :title="`계좌인증`" :content="`계좌의 존재유무 및 은행, 계좌번호, 예금주의 일치 여부를 확인합니다.`"
                    :src="`sub02_icon03.png`" />
                <TableRow_2grid :title="`구매 전용 카드`" :content="`본사↔프랜차이즈, 납품사↔발주사 간 전용카드를 통해 대금을 결제할 수 있습니다.`"
                    :src="`sub02_icon09.png`" />
                <TableRow_2grid :title="`ARS 전화결제`" :content="`주문 접수 후 ARS 시스템을 이용하여 신용카드를 승인하는 서비스입니다.`"
                    :src="`sub02_icon04.png`" />
                <TableRow_2grid :title="`카카오 알림톡, SMS 결제`" :content="`별도의 시스템 구축 없이 고객이 수신 받은 카카오 알림톡이나, SMS를 통한 결제 서비스 제공이 가능합니다.`"
                    :src="`sub02_icon07.png`" />
                <TableRow_2grid :title="`정기 결제 (빌키 결제)`"
                    :content="`카드 인증 후 발급된 빌키(Bill-key)를 통해 원하는 시간에 원하는 금액만큼 예약 결제, 정기 결제가 가능합니다.`"
                    :src="`sub02_icon06.png`" />
                <TableRow_2grid :title="`오프라인 결제`"
                    :content="`다양한 하드웨어 결제솔루션 제공으로 온/오프라인 결제를 PG 서비스로 이용 가능하며 결제 방식에 상관없이 데이터를 통합하여 관리할 수 있습니다.`"
                    :src="`sub02_icon10.png`" />
                <TableRow_2grid :title="`정산 대행 서비스`"
                    :content="`하위 셀러가 있는 플랫폼사업자(가맹점)을 대신하여 각 셀러들에게 정산 집행을 대행하는 서비스입니다.`" :src="`sub02_icon05.png`" />
                <TableRow_2grid :title="`실시간 지급지시 서비스`"
                    :content="`PG 결제와 연계하여 지급지시 계좌에 자동 충전된 금액으로 한도 내에서 실시간 출금을 요청할 수 있습니다.`"
                    :src="`sub02_icon08.png`" />
            </div>
        </SubSection>

        <SubSection type="wide" class="custom_section">
            <SubTitle3 listStyle="dot" class="mb-32">이지페이 가맹점관리자</SubTitle3>
            <SubParagraph1 class="pl-30 c-black3">결제 서비스의 효율적인 운영 관리를 위한 가맹점 전용의 관리자 시스템을 제공합니다.</SubParagraph1>
            <div class="image_box">
                <div class="img"><img src="@/assets/sub02_01.png" alt="" /></div>
                <div class="img"><img src="@/assets/sub02_02.png" alt="" /></div>
                <div class="img"><img src="@/assets/sub02_03.png" alt="" /></div>
            </div>
            <ul>
                <li>- 모든 결제수단에 대한 거래내역을 한눈에 볼 수 있는 통합거래내역 제공</li>
                <li>- 결제수단별, 지급일자별 결제현황 등 다양한 마케팅보고서 및 통계자료 제공</li>
                <li>- 정산/입금 내역을 편리하게 관리할 수 있는 통합정산보고서 제공</li>
                <li>- 부가세 신고 등 세무회계 처리를 위한 자료 제공</li>
            </ul>
        </SubSection>

        <SubSection class="pb-0">
            <SubTitle3 listStyle="dot">서비스 신청 안내</SubTitle3>
            <div class="grid-4">
                <CardBox3 :idx="1" :title="`서비스 신청 및 상담`"
                    :content="'서비스 신청 버튼을 클릭하여 이지페이 가입 신청을 하면 영업 담당자가 지정되어 상담을 진행합니다.'">
                    <OrangeLineButton :text="`서비스 신청`"
                        href="https://www.easypay.co.kr/application/ApplyIntroAction.do" />
                </CardBox3>
                <CardBox3 :idx="2" :title="`계약서 작성`" :content="'계약서와 이용 신청서 등 구비서류를 양식에 맞춰 작성합니다.'">
                    <OrangeLineButton :text="`구비서류 안내`"
                        href="https://www.easypay.co.kr/application/ApplyContractAction.do" />
                </CardBox3>
                <CardBox3 :idx="3" :title="`등록비 결제`"
                    :content="'이지페이에서 제공하는 모든 결제수단을 통해 <br />초기 등록비 결제가 가능합니다. <br />등록비는 계약을 해지하셔도 환불이 불가합니다.'">
                    <OrangeLineButton :text="`등록비 결제`"
                        href="https://www.easypay.co.kr/application/ApplyTradeAction.do" />
                </CardBox3>
                <CardBox3 :idx="4" :title="`보증보험 가입 안내`"
                    :content="'보증보험이란 PG사와 쇼핑몰간의 <br />상호간에 상행위 진행 후, 사고발생에 따라 <br />소비자의 민원 및 피해의 발생으로 해당 쇼핑몰에서 <br />당사와의 계약을 준수하지 못할 경우를<br />대비하기 위한 최소한의 보호장치 입니다.'">
                    <OrangeLineButton :text="`보증보험 안내`"
                        href="https://www.easypay.co.kr/application/ApplyInsuranceAction.do" />
                </CardBox3>
                <CardBox3 :idx="5" :title="`구비서류 접수`"
                    :content="'작성이 완료된 서류를 우편 등으로 발송해주십시오.<br />우편번호: 04513<br />주소: 서울특별시 중구 세종대로 39 <br />대한상공회의소 7층 한국정보통신(주)<br />받는사람: 이지페이 신규 계약 담당자 앞'" />
                <CardBox3 :idx="6" :title="`가맹점 ID 발급 및 시스템 연동`"
                    :content="'모든 준비과 완료되면 가맹점에서 <br />사용 가능한 ID가 생성됩니다<br />발급받으신 가맹점ID로 <br />결제모듈을 연동하시면 됩니다.'" />
                <CardBox3 :idx="7" :title="`금융기관 심사`"
                    :content="'신용카드, 실시간 계좌이체, 휴대폰 결제를 위해서는 <br />각각 카드사와 금융결제원, 통신사의 <br />가맹점 심사가 필요합니다.<br />심사는 영업일 기준 약 5~10일 <br />정도 소요됩니다.'">
                    <OrangeLineButton :text="`진행조회`"
                        href="https://www.easypay.co.kr/application/ApplyProgressAction.do" />
                </CardBox3>
                <CardBox3 :idx="8" :title="`서비스 오픈`" :content="'금융기관 심사가 완료되면 <br />이지페이 서비스를 이용하실 수 있습니다.'" />
            </div>
        </SubSection>
    </LayoutSub>
</template>
<script>
import CardBox3 from '@/components/CardBox3.vue';
import ImageListItem from '@/components/ImageListItem.vue';
import OrangeLineButton from '@/components/OrangeLineButton.vue';
import RedLineButton from '@/components/RedLineButton.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import SubParagraph1 from '@/components/SubParagraph1.vue';
import SubSection from '@/components/SubSection.vue';
import SubTitle3 from '@/components/SubTitle3.vue';
import TableRow_2grid from '@/components/TableRow_2grid.vue';
import TableRow_3grid from '@/components/TableRow_3grid.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubpageTitleContainer,
        RedLineButton,
        TableRow_2grid,
        TableRow_3grid,
        SubTitle3,
        ImageListItem,
        SubParagraph1,
        CardBox3,
        OrangeLineButton,
        SubSection,
    },
};
</script>
<style lang="scss" scoped></style>
